import "./btnScroll.css";
import arrowDownIcon from "../../assets/img/flecha-scroll.svg";
import { useLocation } from 'react-router-dom';

const BtnScroll = () => {
  const location = useLocation();
  // Definimos un array con las rutas donde queremos ocultar el elemento
  const hiddenRoutes = ['/1b108ba2-9767-4f9a-a01b-d55c1fac2d83', '/5bfd0e31-af85-4bb1-91c8-997d81fec963'];
  
  // Verificamos si la ruta actual está incluida en el array
  const isHidden = hiddenRoutes.includes(location.pathname);

  return (
    <div className="container_scroll">
      {!isHidden && <a href="#root">
        <img id="arrow-image" src={arrowDownIcon} />
      </a>}
    </div>
  );
};
export default BtnScroll;
